export const GET_UPLOAD_DATA_ANALYSIS_FILE_FORMAT_MOCK =  {
  fileFormat: 'excel'
}